<template>

  <v-card class="mx-5 mb-5" dark color="primary lighten-1" width="320" v-if="user.emailAddress != this.$store.getters.user.email && user.group.groupName !== 'Administrator'">
    <v-toolbar flat color="primary">
      <v-card-title light>{{user.firstname}} {{user.lastname}}</v-card-title>
      <v-spacer></v-spacer>
      <v-btn fab small light @click="deleteUser">
        <v-icon color="red">mdi-delete</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text>
      <v-radio-group v-model="user.group.id">
        <v-radio
          v-for="group in myGroups"
          :key="group.id"
          :label="group.groupName"
          :value="group.id"
          color="white"
          @change="SaveGroup(group.id)"
        ></v-radio>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios';
export default {
  name: "UserCard",
  props: ["user", "groups"],
  computed: {
    myGroups() {
      return this.groups.filter(gr => gr.groupName !== 'Administrator')
    }
  },
  methods:{ 
      deleteUser(){
          this.$emit('delete', this.user)
      },
      SaveGroup( groupID) {
      let user = {
        user: {
          id: this.user.id,
          usergroupid: groupID
        }
      };

      let mutation = `mutation saveusersgroup($user: SaveUsersGroup!) {
                              saveusersgroup(user : $user ) {
                          id
                        }
                      }`;
      axios
        .post("/graphql", {
          query: mutation,
          variables: user
        })
        .then(res => {
          if (res.data.data.saveusersgroup) {
            this.showSuccess("Rolegroup saved!");
          }
        })
        .catch(() => {
          this.showError("Error while saving rolegroup!");
        });
    },
  }
};
</script>

<style>
</style>